<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>

        <div class="simple-row" v-if="curComLevel == 1">
            <div class="left">
                <button class="swb-btn swb-btn-small mr10" @click="feedbackSave()">
                    <span>新增</span>
                </button>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="feedbackList" border style="width: 100%">
                <el-table-column prop="typeName" label="反馈类型" width="150" align="left"></el-table-column>
                <el-table-column prop="content" label="问题描述" width="260" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" label="创建人" width="150" align="left"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
                <el-table-column label="处理状态" width="100" align="left">
                    <template slot-scope="rows">
                        <a v-if="rows.row.handleFlag == 1">已处理</a>
                        <a v-if="rows.row.handleFlag == -1">不予处理</a>
                    </template>
                </el-table-column>
                <el-table-column prop="replyContent" label="回复内容" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    //
    import merchtComnApi from '../../api/merchtComn'
    import userApi from '../../api/user'
    //
    import SwbFeedbackCreate from './FeedbackCreate';
    Vue.regist(SwbFeedbackCreate);

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "反馈类型",
                "code": "typeName",
                "basic": true
            },
            {
                "type": "Date2",
                "label": "创建时间",
                "code": "createTime",
                "basic": true,
                "valueType": "String"
            },
        ],
        "sortFields": [
            {
                "order": "desc",
                "code": "createTime",
                "label": "创建时间"
            },
        ]
    };

    export default{
        name: 'swb-feedback-list',
        path: '/feedback/list',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '反馈列表',
        helpArticleCode: 'servicer-feedback-list',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                curComLevel: null,
                feedbackList: [],
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                includeSubComs: false,
                comId: null,
                comLevel: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //----------------------搜索排序----------------------------
            this.queryConfig = searchConfigData || {};
            //
            this.getCurrentUserInfo();
            this.getFeedbackList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('.table-layout'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, .search-layout, .simple-row, .pagination-layout'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.curComLevel = scopeEntity.comLevel;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getFeedbackList();
            },
            checkComCatChange: function (eventDate) {
                this.comId = eventDate.id;
                this.comLevel = eventDate.level;
                this.includeSubComs = eventDate.includeSubComs;
                this.getFeedbackList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getFeedbackList();
            },
            getFeedbackList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.comId = this.comId;
                filterItems.comLevel = this.comLevel;
                filterItems.includeSubComs = this.includeSubComs;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                merchtComnApi.getFeedbackList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.feedbackList = result.data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 新增反馈
            feedbackSave: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "新增反馈",
                    showCloseBtn: true,
                    width: 700,
                    height: 400,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-feedback-create ref="web_swb_feedback_create"></swb-feedback-create>' +
                    '</div>',
                    data: {
                        loading: false,
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.web_swb_feedback_create.getDlgResult() || {};
                        if(result !== null) {
                            if(result.type === 'info') {
                                self.loading = true;
                                //
                                selfDlg.feedbackSave(result.data);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        } else {
                            MsgBox.warning("返回出错");
                        }
                        return false;
                    },
                    methods: {
                        feedbackSave: function (postData) {
                            postData.comId = self.comId;
                            //
                            let theLoad = MsgBox.loading();
                            merchtComnApi.saveFeedback(postData, function (result) {
                                theLoad.hide();
                                if(result.type == 'info') {
                                    theDlg.close();
                                    MsgBox.success('提交成功');
                                    //
                                    self.getFeedbackList();
                                } else {
                                    self.loading = false;
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    },
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/feedback/FeedbackList.vue